import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalTemplate, Title } from '@/ui'
import styles from './PositionForm.module.scss'
import { Formik } from 'formik'
import { WorkPlaceForm } from './WorkPlaceForm'
import { useDispatch, useSelector } from 'react-redux'
import * as staffSelectors from '@/entity/staffingProject/selectors'
import * as staffThunks from '@/entity/staffingProject/thunks'
import * as handbookSelectors from '@/entity/handbook/selectors'
import { ValidationSchema } from './validationSchema'
import { LoadingBlocker } from '@/components/Loader'
import { filterWorkPlaceByExternalId } from './utils'
import * as staffingSelectors from '@/entity/staffing/selectors'
import * as staffingThunks from '@/entity/staffing/thunks'
import { DigitalSign } from '@/utils/digitalSign'
import { message } from 'antd'
import { toNumber } from '@/utils/number'

export const WorkPlaceModalForm = ({
	onClose,
	activeStructId,
	staff,
	positionRowSelectMenu,
	setPositionRowSelectMenu,
																		 structureDeptTypeCode,
																		 title,
																		 actions
}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isSuccess = useSelector(staffSelectors.isSuccess)
	const isLoading = useSelector(staffingSelectors.isLoading)
	const positions = useSelector(handbookSelectors.positions)
	const positionsByKnz = useSelector(handbookSelectors.positionsByKnz)
	const laborMobilityCenterCategory = useSelector(handbookSelectors.laborMobilityCenterCategory)

	const digitalSign = new DigitalSign()

	useEffect(() => {
		if (isSuccess) {
			let workPlace = filterWorkPlaceByExternalId(staff.childs[0], editPosition.externalId)
			setPositionRowSelectMenu(workPlace)
			onClose()
		}
	}, [isSuccess])

	let establishedPostNames = { ...positionRowSelectMenu?.establishedPost }
	let otherProps = { ...positionRowSelectMenu }

	// добавляем поле isDicPosition в объект editPosition
	let editPosition = {
		...(establishedPostNames || {}),
		...(otherProps || {}),
		isDicPosition: !establishedPostNames.code ? '2' : '3',
		position: establishedPostNames.code ? establishedPostNames.code : null,
		staffCategory: positionRowSelectMenu?.dstaffCategory?.code,
		positionCode: positionRowSelectMenu?.dposition?.code,
		staffUnitsCount: actions.edit ? otherProps.staffUnitsCount: null
	}

	const editSuccessHandler = (data) => {
		const workPlaceData = {
			orgExternalId: staff.externalId,
			positionGroupExternalId: positionRowSelectMenu.groupId,
			row: {
				factSalary: data.factSalary,
				freelance: data.freelance,
				grossSalary: toNumber(data.grossSalary),
				salarySupplement: toNumber(data.salarySupplement),
				staffFreeCount: data.staffFreeCount,
				staffUnitsCount: data.staffUnitsCount,
				code: data.code,
				externalId: editPosition.externalId,
			},
		}
		if (staff.actual) {
			let newWorkPlace = {
				externalId: editPosition.externalId,
				factSalary: data.factSalary,
				freelance: data.freelance,
				grossSalary: toNumber(data.grossSalary),
				posGroupExternalId: positionRowSelectMenu.groupId,
				salarySupplement: toNumber(data.salarySupplement),
				staffUnitsCount: data.staffUnitsCount,
			}
			const type = 'workPlace'
			let body = {
				newWorkPlace,
				type,
				activeStructId,
				onSuccess: async (xml) => {
					const res = await digitalSign.handleSend(xml)
					let signedBody = {
						data: { data: res },

						onSuccess: () => {
							message.success('Рабочее место успешно изменено!')
							onClose()
						},
						type,
						activeStructId,
						positionGroupExternalId: positionRowSelectMenu.groupId,
					}
					dispatch(staffingThunks.sendSignActualWorkPlace(signedBody))
				},
			}

			dispatch(staffingThunks.setActualWorkPlace(body))
		} else {
			dispatch(staffThunks.editWorkPlace(workPlaceData, activeStructId))
		}
	}

	const addWorkplaceHandler = (data) => {
		let body = {
			data: {
				freelance: data.freelance,
				grossSalary: toNumber(data.grossSalary),
				orgExternalId: staff.externalId,
				positionGroupExternalId: positionRowSelectMenu?.externalId,
				salarySupplement: toNumber(data.salarySupplement),
				workplaceCount: data.staffUnitsCount
			},
			onSuccess: (res) => {
				message.success(t('success'))
				dispatch(staffThunks.getProject({onSuccess: () => {}}))
			}
		}

		dispatch(staffThunks.addWorkPlace(body))
	}

	const onSubmit = (data) => {
		if(actions.edit){
			editSuccessHandler(data)
		} else if(actions.add_workplace){
			addWorkplaceHandler(data)
		}
	}

	return (
		<>
			<ModalTemplate onClose={onClose} priority={2}>
				<div className={`scroll ${styles.wrapper}`}>
					<div className={styles.mt10}>
						<Title color="black">{title}</Title>
						<Formik
							validationSchema={ValidationSchema(actions)}
							initialValues={editPosition}
							onSubmit={onSubmit}
							enableReinitialize
						>
							{positions?.length > 0 && positionsByKnz.length > 0 && laborMobilityCenterCategory.length > 0 ? (
								<WorkPlaceForm
									onClose={onClose}
									positions={positions}
									positionsByKnz={positionsByKnz}
									laborMobilityCenterCategory={laborMobilityCenterCategory}
									structureDeptTypeCode={structureDeptTypeCode}
									actions={actions}
								></WorkPlaceForm>
							) : (
								<LoadingBlocker localStyles={{ width: '65vw', height: '50vw' }} />
							)}
						</Formik>
					</div>
				</div>
			</ModalTemplate>

			{isLoading ? <LoadingBlocker /> : null}
		</>
	)
}
